import './Error404.scss';
import Component from './Error404.js';
export default Component;
